import { navbarContainerStyle } from "./navbarUtils";
import ThemeSelector from "./ThemeSelector";

const BaseNavbar = ({ startContent, centerContent, endContent, className = "" }) => {
    return (
        <nav className={`${navbarContainerStyle} ${className}`}>
            <div className="navbar-start">{startContent}</div>
            <div className="navbar-center">{centerContent}</div>
            <div className="navbar-end">{endContent || <ThemeSelector />}</div>
        </nav>
    );
};

export default BaseNavbar;
